// Shared types and constants for the stacked time-series panel and the
// consumers that key their own UI to it (e.g. a table whose row dot colors
// match the chart legend). Kept in a non-component module so the panel
// component file satisfies the react-refresh "only export components" rule.

// The base label of a top-N remainder rollup series (a collision with a real
// group appends suffixes). The label is display-only: neutral rollup
// rendering is driven by TimeSeriesStack.rollup, never by this string.
export const OTHER_STACK_LABEL = "Other";

// One stacked series: a daily value series aligned by index to the panel's
// bucket grid. `rollup` marks a synthetic top-N remainder series — it renders
// in the theme-resolved rollup neutral (useOtherSeriesColor) regardless of
// its label, so a real group that happens to display as "Other" can't be
// mistaken for it.
export type TimeSeriesStack = {
  /** Stable chart identity. Falls back to label for existing callers. */
  key?: string;
  label: string;
  series: number[];
  /** Stable index into the shared chart palette, independent of filtering. */
  paletteIndex?: number;
  /**
   * Exact decimal integers aligned to series. Meter callers use these for
   * rollups, cumulative values, and tooltips; Number values remain chart
   * coordinates only.
   */
  exactSeries?: string[];
  rollup?: boolean;
  /**
   * The "unset"/unattributed group. It draws hollow — a box outlined in the
   * neutral rather than filled — everywhere the series appears (bar segment,
   * legend swatch, table swatch), because it is the absence of a category
   * rather than one more category competing for a color.
   */
  unset?: boolean;
};
